




import Vue from 'vue'
import ShowBankName from '@/components/molecules/ShowBankName.vue'

export default Vue.extend({
  name: 'BankNameHamamatsuIwata',
  components: {
    ShowBankName
  },
  props: {
    bankName: String
  }
})
